import { BOPISOrderStatus, HomeDeliveryOrderStatus } from '@/data/constants/order';

export const HOME_DELIVERY_STEP_LABELS: Record<HomeDeliveryOrderStatus, string> = {
	// Step 1
	[HomeDeliveryOrderStatus.G]: 'Recibida',
	[HomeDeliveryOrderStatus.M]: 'Recibida',
	[HomeDeliveryOrderStatus.A]: 'Pendiente',

	// Step 2
	[HomeDeliveryOrderStatus.R]: 'En preparación',

	// Step 3
	[HomeDeliveryOrderStatus.S]: 'En proceso',
	[HomeDeliveryOrderStatus.SE]: 'En proceso',
	[HomeDeliveryOrderStatus.ER]: 'En proceso',

	// Step 4
	[HomeDeliveryOrderStatus.T]: 'En camino',

	// Step 5
	[HomeDeliveryOrderStatus.D]: 'Entregada',

	// Defined but not used in react.
	[HomeDeliveryOrderStatus.P]: 'En transferencia',
	[HomeDeliveryOrderStatus.X]: 'Cancelado',
	[HomeDeliveryOrderStatus.PX]: 'En proceso',
};

export const HOME_DELIVERY_STEP_DESCRIPTIONS: Record<HomeDeliveryOrderStatus, string> = {
	// Step 1
	[HomeDeliveryOrderStatus.G]: 'Hemos recibido tu orden',
	[HomeDeliveryOrderStatus.M]: 'Hemos recibido tu orden',
	[HomeDeliveryOrderStatus.A]: 'Asegura tus productos, finaliza tu compra',

	// Step 2
	[HomeDeliveryOrderStatus.R]: 'Estamos validando el inventario de tu orden',

	// Step 3
	[HomeDeliveryOrderStatus.S]: 'Estamos programando el envío de tu orden',
	[HomeDeliveryOrderStatus.SE]: 'Estamos programando el envío de tu orden',
	[HomeDeliveryOrderStatus.ER]: 'Estamos programando el envío de tu orden',

	// Step 4
	[HomeDeliveryOrderStatus.T]: 'Tu orden está en camino',

	// Step 5
	[HomeDeliveryOrderStatus.D]: 'Hemos entregado tu orden',

	// Defined but not used in react.
	[HomeDeliveryOrderStatus.P]: 'En transferencia',
	[HomeDeliveryOrderStatus.X]: 'Cancelado',
	[HomeDeliveryOrderStatus.PX]: 'En proceso',
};

export const BOPIS_STEP_LABELS: Record<BOPISOrderStatus, string> = {
	// Step 1
	[BOPISOrderStatus.G]: 'Recibida',
	[BOPISOrderStatus.M]: 'Recibida',
	[BOPISOrderStatus.A]: 'Pendiente',

	// Step 2
	[BOPISOrderStatus.R]: 'En preparación',

	// Step 3
	[BOPISOrderStatus.S]: 'Lista para recoger',
	[BOPISOrderStatus.SE]: 'Lista para recoger',
	[BOPISOrderStatus.ER]: 'Lista para recoger',

	// Step 4
	[BOPISOrderStatus.D]: 'Entregada',

	// Defined but not used in react.
	[BOPISOrderStatus.P]: 'En transferencia',
	[BOPISOrderStatus.X]: 'Cancelado',
	[BOPISOrderStatus.PX]: 'En proceso',
};

export const BOPIS_STEP_DESCRIPTIONS: Record<BOPISOrderStatus, string> = {
	// Step 1
	[BOPISOrderStatus.G]: 'Hemos recibido tu orden',
	[BOPISOrderStatus.M]: 'Hemos recibido tu orden',
	[BOPISOrderStatus.A]: 'Asegura tus productos, finaliza tu compra',

	// Step 2
	[BOPISOrderStatus.R]: 'Estamos validando el inventario de tu orden',

	// Step 3
	[BOPISOrderStatus.S]: 'Ya puedes recoger tu orden',
	[BOPISOrderStatus.SE]: 'Ya puedes recoger tu orden',
	[BOPISOrderStatus.ER]: 'Ya puedes recoger tu orden',

	// Step 4
	[BOPISOrderStatus.D]: 'Hemos entregado tu orden',

	// Defined but not used in react.
	[BOPISOrderStatus.P]: 'En transferencia',
	[BOPISOrderStatus.X]: 'Cancelado',
	[BOPISOrderStatus.PX]: 'En proceso',
};

export const HOME_DELIVERY_STATUS_TO_STEP: Partial<Record<HomeDeliveryOrderStatus, number>> = {
	[HomeDeliveryOrderStatus.G]: 0,
	[HomeDeliveryOrderStatus.M]: 0,
	[HomeDeliveryOrderStatus.A]: 0,
	[HomeDeliveryOrderStatus.R]: 1,
	[HomeDeliveryOrderStatus.S]: 2,
	[HomeDeliveryOrderStatus.SE]: 2,
	[HomeDeliveryOrderStatus.ER]: 2,
	[HomeDeliveryOrderStatus.T]: 3,
	[HomeDeliveryOrderStatus.D]: 4,
};

export const BOPIS_STATUS_TO_STEP: Partial<Record<BOPISOrderStatus, number>> = {
	[BOPISOrderStatus.G]: 0,
	[BOPISOrderStatus.M]: 0,
	[BOPISOrderStatus.A]: 0,
	[BOPISOrderStatus.R]: 1,
	[BOPISOrderStatus.S]: 2,
	[BOPISOrderStatus.SE]: 2,
	[BOPISOrderStatus.ER]: 2,
	[BOPISOrderStatus.D]: 3,
};

export const HOME_DELIVERY_STEPS = [0, 1, 2, 3, 4];
export const BOPIS_STEPS = [0, 1, 2, 3];

export const PAYMENT_METHODS_REQUIRING_PENDING_STATUS = ['Oxxo', 'OpenPay', 'PayInStore'];

// Matches react oder details page sm breakpoint.
export const SM_SCREEN_MAX_WIDTH = 960;
